import React from 'react'
import { Clock } from 'react-feather'

import SchedulerSection from '@/components/integration/nylas/scheduler/components/SchedulerSection'
import TimeslotPickerButton from '@/components/integration/nylas/scheduler/components/timeslotPicker/TimeslotPickerButton'
import { useSchedulerSelection } from '@/components/integration/nylas/scheduler/context/SchedulerSelectionContext'
import useSelectedSchedulerDay from '@/components/integration/nylas/scheduler/hooks/useSelectedSchedulerDay'
import { Heading } from '@/components/ui/heading'

interface Props {
  duration?: number
}

const TimeslotPicker: React.FC<Props> = ({ duration }) => {
  const { selectedDateTime, selectDateTime } = useSchedulerSelection()
  const schedulerDay = useSelectedSchedulerDay()

  if (!schedulerDay) {
    return <div>No timeslots available on this day</div>
  }

  return (
    <SchedulerSection autoScrollOnMount>
      <hr className="my-6" />

      <Heading
        size={4}
        className="mb-4 flex items-center justify-between gap-2"
      >
        <div className="flex items-center gap-2">
          <Clock size={16} />
          <div>Start time</div>
        </div>

        {duration !== undefined && (
          <div className="justify-self-end text-xs">
            {duration} minute meeting
          </div>
        )}
      </Heading>

      <div
        className="mb-6 grid grid-cols-1 flex-wrap gap-3 @xs:grid-cols-2
          @sm:grid-cols-3 @md:grid-cols-4 @lg:grid-cols-5 @xl:grid-cols-6"
      >
        {schedulerDay.timeSlotStartTimes.map((startDate, i) => (
          <TimeslotPickerButton
            key={startDate.toISOString()}
            startDate={startDate}
            isSelected={
              selectedDateTime?.toISOString() === startDate.toISOString()
            }
            onClick={() => selectDateTime(startDate)}
            index={i}
          />
        ))}
      </div>
    </SchedulerSection>
  )
}

export default TimeslotPicker
